import { useEffect, useRef } from "react";
import { Page } from "react-pdf";

import { usePdfPageWindow } from "@/Utils/usePdfPageWindow";

const THUMBNAIL_SCALE = 0.15;
// US Letter at scale 1, used until the real page size is known.
// const FALLBACK_PAGE_SIZE = { width: 612, height: 792 };

// const thumbnailSize = (pageSizes, baselineSize, pageNumber) => {
//   const size = pageSizes?.[pageNumber] || baselineSize || FALLBACK_PAGE_SIZE;
//   return {
//     width: size.width * THUMBNAIL_SCALE,
//     height: size.height * THUMBNAIL_SCALE,
//   };
// };

/**
 * The rail shell: the scrolling container plus an empty element that
 * PageRailPages is portaled into.
 *
 * The rail no longer opens the PDF itself. Splitting the shell from the pages
 * lets the thumbnails render as children of the viewer's <Document> — sharing
 * its single load — while still sitting here in the DOM.
 */
export const PageRail = ({ scrollRef, portalRef }) => (
  <div
    className="pdf-thumbnail"
    style={{
      paddingLeft: "10px",
      paddingRight: "10px",
      width: "120px",
      backgroundColor: "var(--primary-10)",
      scrollbarWidth: "none",
      minWidth: "120px",
    }}
    ref={scrollRef}
  >
    <div className="pdf-thumbnail-pages" ref={portalRef} />
  </div>
);

/**
 * The thumbnails themselves. Rendered inside the shared <Document> and
 * portaled into the rail, so <Page> still finds react-pdf's DocumentContext.
 *
 * Every thumbnail keeps a correctly sized wrapper so the rail scrolls and
 * scrollIntoView behaves, but only thumbnails near the viewport mount a
 * canvas — an offscreen canvas would pull its page's bytes over the wire.
 */
export const PageRailPages = ({
  numPages,
  currentPage,
  scrollRootEl,
  // pageSizes,
  // baselineSize,
  onThumbnailClick,
  setPageNumber,
}) => {
  const thumbnailRef = useRef(null);
  const visiblePages = usePdfPageWindow(scrollRootEl, numPages, {
    selector: ".thumbnail-page",
    rootMargin: "100% 0px",
  });

  // Effect to scroll to the selected thumbnail
  useEffect(() => {
    if (thumbnailRef.current) {
      thumbnailRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [currentPage]);

  return (
    <>
      {Array.from({ length: numPages || 0 }, (_, index) => {
        const pageNumber = index + 1;
        // const { width, height } = thumbnailSize(pageSizes, baselineSize, pageNumber);

        return (
          <div
            key={index}
            id={`thumbnail_pdf_page_${pageNumber}`}
            data-window-key={pageNumber}
            className={`thumbnail-page ${currentPage === pageNumber ? "page-selected" : ""}`}
            style={{ marginTop: "10px" }}
            ref={currentPage === pageNumber ? thumbnailRef : null}
            onClick={() => onThumbnailClick(pageNumber, setPageNumber)}
          >
            {visiblePages.has(pageNumber) && (
              <Page
                scale={THUMBNAIL_SCALE}
                pageNumber={pageNumber}
                renderTextLayer={false}
                renderAnnotationLayer={false}
              />
            )}
          </div>
        );
      })}
    </>
  );
};

export default PageRail;
